export { default as ContentClipOutlineIcon } from './ContentClipOutlineIcon';
